import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import ContentHome from "../../components/Home/ContentHome";
import Footer from "../../components/Footer/Footer";
import Downloader from "../../components/Botones/Downloader";

function Home() {
  return (
    <div>
      <Navbar />
      <Downloader />
      <ContentHome />
      <Footer />
    </div>
  );
}

export default Home;
